import { v4 as uuid } from 'uuid';
import {
  CalculatorKeys,
  CalculatorStepType,
  CalculatorStateType,
} from '../@types/cash';

export const cashFlowSteps: CalculatorStepType[] = [
  {
    id: uuid(),
    name: CalculatorKeys.INCOME,
    label: 'Încasări',
    items: [
      {
        id: uuid(),
        name: 'incasari_din_vanzari',
        label: 'Încasări din vânzări',
      },
      {
        id: uuid(),
        name: 'incasari_din_credite_primite',
        label: 'Încasări din credite primite',
      },
      {
        id: uuid(),
        name: 'alte_intrari_de_numerar',
        label: 'Alte intrări de numerar',
      },
      {
        id: uuid(),
        name: 'incasari_din_imprumuturi_actionari',
        label: 'Încasări din împrumuturi acționari',
      },
    ],
  },
  {
    id: uuid(),
    name: CalculatorKeys.COSTS,
    label: 'Plăți Activitate Operațională',
    items: [
      {
        id: uuid(),
        name: 'cheltuieli_cu_materii_prime_aferente_activitatii_desfasurate',
        label: 'Plată furnizori',
      },
      {
        id: uuid(),
        name: 'salarii',
        label: 'Plata salarii',
      },
      {
        id: uuid(),
        name: 'chirii',
        label: 'Plată chirie',
      },
      {
        id: uuid(),
        name: 'utilitati',
        label: 'Plată utilități (apă, en.el., gaze, telefon)',
      },
      {
        id: uuid(),
        name: 'transport_combustibil',
        label: 'Plată transport / combustibil',
      },
      {
        id: uuid(),
        name: 'consumabile_obiecte_de_inventar',
        label: 'Plată avansuri spre decontare',
      },
      {
        id: uuid(),
        name: 'costuri_functionare_birou',
        label: 'Plată contracte sponsorizare',
      },
      {
        id: uuid(),
        name: 'cheltuieli_de_marketing',
        label: 'Plată comisioane bancare',
      },
      {
        id: uuid(),
        name: 'asigurari',
        label: 'Plată alte taxe - autorizații',
      },
      {
        id: uuid(),
        name: 'reparatii_intretinere',
        label: 'Plată amenzi și penalități',
      },
      {
        id: uuid(),
        name: 'comisioane_bancare',
        label: 'Plată impozite salariale',
      },
      {
        id: uuid(),
        name: 'servicii_cu_tertii',
        label: 'Plată impozit pe profit / venit',
      },
      {
        id: uuid(),
        name: 'impozite_si_taxe',
        label: 'Plată TVA',
      },
      {
        id: uuid(),
        name: 'tva_de_platit',
        label: 'Plată impozite și taxe locale - DITL',
      },
      {
        id: uuid(),
        name: 'alte_cheltuieli',
        label: 'Alte plăți',
      },
    ],
  },
  {
    id: uuid(),
    name: CalculatorKeys.OTHER,
    label: 'Plăți Financiare și Investiții',
    items: [
      {
        id: uuid(),
        name: 'achizitii_mijloace_fixe',
        label: 'Achiziții mijloace fixe',
      },
      {
        id: uuid(),
        name: 'rambursari_rate_de_credit',
        label: 'Rambursări rate de credit',
      },
      {
        id: uuid(),
        name: 'dobanzi_si_comisioane',
        label: 'Dobânzi și comisioane',
      },
      {
        id: uuid(),
        name: 'alte_credite_rambursari_rate_de_credit',
        label: 'Rambursări rate de credit',
      },
      {
        id: uuid(),
        name: 'alte_credite_dobanzi_si_comisioane',
        label: 'Dobânzi și comisioane',
      },
      {
        id: uuid(),
        name: 'descresteri_imprumuturi_actionari',
        label: 'Descreșteri împrumuturi acționari',
      },
      {
        id: uuid(),
        name: 'dividende_brute',
        label: 'Dividende brute',
      },
    ],
  },
];

export const profitSteps: CalculatorStepType[] = [
  {
    id: uuid(),
    name: CalculatorKeys.INCOME,
    label: 'Venituri',
    items: [
      {
        id: uuid(),
        name: 'venituri_din_activitatea_de_baza',
        label: 'Venituri din activitatea de bază',
      },
      {
        id: uuid(),
        name: 'alte_venituri',
        label: 'Alte venituri',
      },
    ],
  },
  {
    id: uuid(),
    name: CalculatorKeys.COSTS,
    label: 'Cheltuieli',
    items: [
      {
        id: uuid(),
        name: 'combustibil',
        label: 'Combustibil',
      },
      {
        id: uuid(),
        name: 'transport',
        label: 'Transport',
      },
      {
        id: uuid(),
        name: 'obiecte_de_inventar',
        label: 'Obiecte de inventar',
      },
      {
        id: uuid(),
        name: 'consumabile',
        label: 'Consumabile',
      },
      {
        id: uuid(),
        name: 'reparatii_mentenanta',
        label: 'Reparații & mentenanță',
      },
      {
        id: uuid(),
        name: 'asigurari',
        label: 'Asigurări',
      },
      {
        id: uuid(),
        name: 'servicii',
        label: 'Servicii',
      },
      {
        id: uuid(),
        name: 'utilitati',
        label: 'Utilități (en.el., gaze, apă, tel.)',
      },
      {
        id: uuid(),
        name: 'chirie',
        label: 'Chirie',
      },
      {
        id: uuid(),
        name: 'deplasari',
        label: 'Deplasări',
      },
      {
        id: uuid(),
        name: 'publicitate_promovare',
        label: 'Publicitate & promovare',
      },
      {
        id: uuid(),
        name: 'salarii',
        label: 'Salarii',
      },
      {
        id: uuid(),
        name: 'taxe_si_contributii_sociale',
        label: 'Taxe și contribuții salariale',
      },
      {
        id: uuid(),
        name: 'impozit_pe_venit',
        label: 'Impozit pe venit',
      },
      {
        id: uuid(),
        name: 'impozit_pe_profit_de_plata',
        label: 'Impozit pe profit',
      },
      {
        id: uuid(),
        name: 'alte_taxe_la_bs',
        label: 'Alte taxe la BS',
      },
      {
        id: uuid(),
        name: 'comisioane_bancare',
        label: 'Comisioane bancare',
      },
      {
        id: uuid(),
        name: 'alte_cheltuieli',
        label: 'Alte cheltuieli',
      },
    ],
  },
];

export const generateDefaultState = (steps: CalculatorStepType[], initData?: CalculatorStateType) =>
  steps.reduce(
    (accParent, currParent) => ({
      ...accParent,
      [currParent.name]: currParent.items.reduce(
        (acc, curr) => ({
          ...acc,
          [curr.name]: initData ? {
            active: true,
            value: initData[currParent.name][curr.name],
            status: 'success'
          } : {
            active: true,
            value: '',
            status: null
          },
        }),
        {},
      ),
    }),
    {} as CalculatorStateType,
  );